<script setup lang="ts">
withDefaults(defineProps<{ size?: number; label?: string }>(), { size: 16 })
</script>

<template>
  <span
    role="status"
    :aria-label="label ?? 'Wird geladen'"
    class="inline-flex"
  >
    <svg
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.25"
      stroke-linecap="round"
      class="animate-[spin_700ms_linear_infinite] motion-reduce:animate-none"
      aria-hidden="true"
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        class="opacity-25"
      />
      <path d="M21 12a9 9 0 0 0-9-9" />
    </svg>
  </span>
</template>
